(function (appComponents) {
	// move to gridlist proto
	appComponents.controllers.quotesOverview = function (Components) {
		var quotesOverview = {};

		quotesOverview.name = "quotesOverview";
		quotesOverview.currentTabView = "list";

		Components.getControllerPrototype().extend(quotesOverview);

		quotesOverview._quotes = quotesOverview._getService("quotesBase");
		quotesOverview._b2bUnit = quotesOverview._getService("b2bUnit");
		quotesOverview._helpers = quotesOverview._getService("helpers");
		quotesOverview.pager = quotesOverview._helpers.getPager(quotesOverview);

		quotesOverview.opts = {
			numToDisplay: 12
		};

		quotesOverview.context.pagerData = quotesOverview.pager.data;

		quotesOverview.elements = {
			get quotesGrid() {
				return $('[pc-container="quotes--grid"]');
			},
			get quotesList() {
				return $('[pc-container="quotes--list"]');
			},
			get quotesGridSaved() {
				return $('[pc-container="quotes--grid-saved"]');
			},
			get quotesListSaved() {
				return $('[pc-container="quotes--list-saved"]');
			},
			get resultsOverall() {
				return $('[pc-container="quotes--results-overall"]');
			},
			get searchQuotesResults() {
				return $('[pc-container="quotes--search-quotes-results"]');
			},
			get filtersForm() {
				return $('[pc-container="quotes--filters-form"]');
			},
			get searchByTermForm() {
				return $('[pc-container="quotes--search-by-term-form"]');
			},
			get searchByCustomerForm() {
				return $('[pc-container="quotes--search-by-customer-form"]');
			}

		};

		quotesOverview.bindings = function () {
			quotesOverview._elements.page.on("click", '[pc-container="quotes--export-to-excel-button"]', function () {
				// inputs 
				var form = $('[pc-container="quotes--export-to-excel-form"]');
				quotesOverview.handlers.onExportToExcel(form);
			});
			quotesOverview._elements.page.on("click", '[pc-container="quotes--set-view-btn"]', function () {
				var type = $(this).attr("pc-value");
				quotesOverview.handlers.onSetTabView(type);
			});

			quotesOverview._elements.page.on("submit", '[pc-container="quotes--filters-form"]', function () {
				quotesOverview.handlers.onFilterFormSubmit(this);
				return false;
			});

			quotesOverview._elements.page.on("submit", '[pc-container="quotes--search-by-term-form"]', function () {
				quotesOverview.handlers.onFilterFormSubmit(this);
				return false;
			});

			quotesOverview._elements.page.on("submit", '[pc-container="quotes--search-by-customer-form"]', function () {
				quotesOverview.handlers.onFilterFormSubmit(this);
				return false;
			});

			quotesOverview._elements.page.on("click", '[pc-container="quotes--reset-filters-btn"]', function () {
				quotesOverview.elements.filtersForm.find("input").val("");
				quotesOverview.elements.searchByTermForm.find("input").val("");
				quotesOverview.elements.searchByCustomerForm.find("input").val("");
				quotesOverview.handlers.onResetFilters();
			});

		};

		quotesOverview.populateInitialContext = function () {
			quotesOverview.context.searchData = quotesOverview._queryData;
			return $.Deferred().resolve();
		};

		quotesOverview.renderQuotes = function (ignoreAnim) {
			quotesOverview._renderTemplate("searchQuotesResults", null, ignoreAnim);
		};

		quotesOverview.renderResultsOverall = function () {
			var html = quotesOverview.templates.resultsOverall(quotesOverview.context);
			quotesOverview.elements.resultsOverall.html(html);
		};

		quotesOverview.checkTabView = function () {
			if (quotesOverview.currentTabView == "list") {
				quotesOverview.context.listTabActiveClass = "active";
				quotesOverview.context.gridTabActiveClass = "";
				$("#list_quote").addClass("active");
				$("#grid_quote").removeClass("active");
			} else if (quotesOverview.currentTabView == "grid") {
				quotesOverview.context.listTabActiveClass = "";
				quotesOverview.context.gridTabActiveClass = "active";
				$("#grid_quote").addClass("active");
				$("#list_quote").removeClass("active");
			}
		};

		quotesOverview.renderSearchResults = function (ignoreAnim) {
			quotesOverview.checkTabView();

			quotesOverview.renderQuotes(ignoreAnim);
			quotesOverview.renderResultsOverall();
		};

		quotesOverview.prepareSearchData = function () {
			var searchData = quotesOverview._queryData;

			if (!searchData.resultsPerPage) {
				searchData = {
					resultsPerPage: quotesOverview.opts.numToDisplay,
					pageNumber: 1
				};

				quotesOverview._updateUrlQuery("replace", searchData);
			}

			return searchData;

		};

		quotesOverview.parseGetQuotesResponse = function (data) {
			quotesOverview.pager.data = data.pagination;
			quotesOverview.context.quotes = data.results;
			quotesOverview.context.pagerData = quotesOverview.pager.data;
		};

		quotesOverview.searchQuotesWithPager = function (ignoreAnim) {
			var searchData = quotesOverview.prepareSearchData();

			quotesOverview._quotes.search(searchData).then(function (data) {
				if (data && data.results) {
					quotesOverview.parseGetQuotesResponse(data);
					quotesOverview.renderSearchResults(ignoreAnim);
				} else {
					quotesOverview.context.quotes = [];
					quotesOverview.renderResultsOverall(ignoreAnim);
				}
			});
		};

		quotesOverview.handlers = {
			onResetFilters: function () {
				quotesOverview.pager.reset();
				var filtersForm = quotesOverview.elements.filtersForm[0];
				quotesOverview.handlers.onFilterFormSubmit(filtersForm);
			},
			onExportToExcel: function (form) {
				var searchData = quotesOverview.prepareSearchData();
				searchData.CSRFToken = quotesOverview.context.config.token;
				searchData.customerIndexNo = quotesOverview._b2bUnit.currentUnit.uid;
				quotesOverview._helpers.populateFormWithHiddenFields(form, searchData);
				$(form).submit();
			},
			onSetTabView: function (type) {
				quotesOverview.currentTabView = type;
			},
			onb2bUnitChange: function () {
				if (quotesOverview._isActiveController) {
					quotesOverview.searchQuotesWithPager();
				}
			},
			onQuoteDeleted: function () {
				quotesOverview.searchQuotesWithPager();
			},
			onFilterFormSubmit: function (form) {
				var access = quotesOverview._b2bUnit.checkB2BUnit();
				if (!access) {
					quotesOverview._modals.warning.show(quotesOverview._messages.noB2bUnitSelected);
					return;
				}

				var formData = quotesOverview._utils.getFormData(form, true);

				quotesOverview.pager.reset();

				var pagerData = {
					pageNumber: quotesOverview.pager.pageToSet,
					resultsPerPage: quotesOverview.pager.pageSize
				};

				var queryData = jQuery.extend({}, formData, pagerData);

				quotesOverview._updateUrlQuery("push", queryData);

				quotesOverview.searchQuotesWithPager();

			},
			pager: {
				onPagerClick: function () {
					quotesOverview._updateUrlQueryWithPagerData("push");
					quotesOverview.searchQuotesWithPager("ignoreAnim");
				}
			}

		};


		quotesOverview.init = function () {

			quotesOverview.populateInitialContext().then(function () {

				quotesOverview._renderPageTemplate();

				quotesOverview._bindings();

				quotesOverview.pager.init();

				quotesOverview.searchQuotesWithPager();

				quotesOverview._events.registerHandlerAsLastOne("b2bUnitChanged", quotesOverview.name, quotesOverview.handlers.onb2bUnitChange);
				quotesOverview._events.registerHandlerAsLastOne("quoteDeleted", quotesOverview.name, quotesOverview.handlers.onQuoteDeleted);

				quotesOverview._events.dispatchEvent("controllerInitialized");
			}).fail(function (e) {
				console.log(e);
			});

		};

		return quotesOverview;
	};

	window.appComponents = appComponents;

})(window.appComponents || {});